class DetectScroll extends HTMLElement {
    connectedCallback() {
        addEventListener('scroll', (event) => {
            this.dispatchEvent(new CustomEvent('customScroll', { detail: window.scrollY }))
        })
    }
}

customElements.define('detect-scroll', DetectScroll)